// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_index_menu__3-k_7","menuItem":"Menu_index_menuItem__1y9K5","swap":"Menu_index_swap__tumhc","edit":"Menu_index_edit__39-0h","active":"Menu_index_active__1wUIV"};